import { useSectionInteraction } from './SectionInteractionContext'
import { classNames } from 'src/lib/utils/helpers'

export const SectionWrapper: React.FC<{
  sectionKey: string
  children: React.ReactNode
  className?: string
  overlayClassName?: string
}> = ({ sectionKey, children, className, overlayClassName }) => {
  const { registerRef } = useSectionInteraction()
  return (
    <div className={`relative ${className || ''}`}>
      {children}
      <div
        ref={node => registerRef(sectionKey, node)}
        className={classNames(
          'absolute inset-0 pointer-events-none rounded-xl z-20 bg-yellow-300/20 opacity-0',
          overlayClassName || ''
        )}
      />
    </div>
  )
}
